class TaskDeliverableCommentPermission
{
    // Admin privileges, other permissions are not checked
    static ROOT = 'task_deliverable_comment.*';

    // Enabled flag: if not present, access denied on any operation. Not required for root
    static _ENABLED = 'task_deliverable_comment._m';

    // Can access archived comment
    static ACCESS_ARCHIVE = 'task_deliverable_comment.access.archive';

    // Can access resolved comment
    static ACCESS_RESOLVED = 'task_deliverable_comment.access.resolved';

    // Can access internal comment
    static ACCESS_INTERNAL = 'task_deliverable_comment.access.internal';

    // Can create regular comments
    static CREATE = 'task_deliverable_comment.create';

    // Can create regular comments if assigned to a task
    static CREATE_MOD_TASK_ASSIGNED = 'task_deliverable_comment.create.mod.task_assigned';

    // Can create internal comments
    static CREATE_INTERNAL = 'task_deliverable_comment.create.internal';

    // Can create internal comments if assigned to a task
    static CREATE_INTERNAL_MOD_TASK_ASSIGNED = 'task_deliverable_comment.create.internal.mod.task_assigned';

    // Update task deliverable comment
    static UPDATE = 'task_deliverable_comment.update';

    // Mark comment as resolved
    static RESOLVE = 'task_deliverable_comment.resolve';

    // Remove resolved status from comment
    static UNRESOLVE = 'task_deliverable_comment.unresolve';

    // Archive task deliverable comment
    static ARCHIVE = 'task_deliverable_comment.archive';

    // Restore archived task deliverable comment
    static RESTORE = 'task_deliverable_comment.restore';

}

export default TaskDeliverableCommentPermission;
